const UTM_PARAMS: string[] = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
const ROISTAT_COOKIE = 'roistat_visit';
const TRACKING_COOKIES: string[] = [ROISTAT_COOKIE, ...UTM_PARAMS];

const COOKIE_MAX_AGE = 60 * 60 * 24 * 30;

class UTM {
    public init(): void {
        const urlParams = new URLSearchParams(window.location.search);

        UTM_PARAMS.forEach((param: string) => {
            const value = urlParams.get(param);

            if (!value) {
                return;
            }

            this._setCookie(param, value);
        });
    }

    public getTrackingParams(): Record<string, string> {
        const params: Record<string, string> = {};

        TRACKING_COOKIES.forEach((name: string) => {
            const value = this._getCookie(name);

            if (!value) {
                return;
            }

            params[name] = value;
        });

        return params;
    }

    private _setCookie(name: string, value: string): void {
        document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
    }

    private _getCookie(name: string): string {
        const cookies = document.cookie ? document.cookie.split('; ') : [];

        for (const cookie of cookies) {
            const separatorIndex = cookie.indexOf('=');
            const cookieName = separatorIndex === -1 ? cookie : cookie.slice(0, separatorIndex);

            if (cookieName === name) {
                const rawValue = separatorIndex === -1 ? '' : cookie.slice(separatorIndex + 1);

                try {
                    return decodeURIComponent(rawValue);
                } catch {
                    return rawValue;
                }
            }
        }

        return '';
    }
}

export default UTM;
